module.exports = __webpack_public_path__ + "img/reward16.8fbd9968.jpg";